var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',_vm._b({attrs:{"contain":"","src":_vm.img}},'v-img',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }